import { ComponentLoader } from 'views/Member/components/ComponentLoader';
import dashboardContext from '../useDashboardContext';

const DashboardLoader: React.VFC = () => {
  const { isTasksLoading } = dashboardContext.useController();
  return <ComponentLoader isLoading={isTasksLoading} />;
};

export default DashboardLoader;
